/* global G */
import seqRead from '@gaia/sequence/model/api/read'
import { setKey } from 'lib/util'

const descriptor = Symbol('hook::model::read').toString()

/**
 * Model Read Attribute Hook.
 *
 * Executes sequence read with model attribute, which in turn maps payload to provided by the passed
 * component.
 *
 * It attempts to obtain a local draft in the first place.
 *
 * If `attributeName` is `null`, attempts to execute read with the main model.
 *
 * @param attributeName name of the model attribute to read
 */
const readAttributeWithDrafts = (
  attributeName: string | null
) => (
  obj: Gaia.AppModule.Spec,
) => async (
  ...args: any[]
) => {
  const { drafts } = obj[G.ADAPTER][G.PERSISTENCE]
  const mainModel = obj[G.MODEL]
  const model = attributeName ? mainModel[G.CHILDREN][attributeName] : mainModel

  if (attributeName && mainModel[G.STATE][G.REF] && !model[G.STATE][G.REF]) {
    setKey(mainModel[G.STATE][G.REF], G.REF, model[G.STATE])
  }

  try {
    const id = model[G.STATE][G.REF]
    const draft = await drafts.get(id)
    if (draft) {
      model[G.CACHE] = draft.data
    }
    await seqRead(model)(obj[G.STATE][G.ACTION][G.COMPONENT])
  } catch (e: any) {
    throw Error(`${obj._name} ${descriptor} - ${e.message}`, { cause: e })
  }

  return args
}

/**
 * Model Read Hook.
 *
 * Executes sequence read, which in turn maps payload to provided by the passed component.
 *
 * It attempts to obtain a local draft in the first place.
 *
 * @param obj current module
 */
const readWithDrafts = (
  obj: Gaia.AppModule.Spec,
) => async (
  ...args: any[]
) => {
  return await readAttributeWithDrafts(null)(obj)(...args)
}

export {
  readWithDrafts as default,
  readAttributeWithDrafts
}
